module.exports = __webpack_public_path__ + "static/media/cover.bb79dcaf.png";